import React from 'react';
import { DoughnutChart } from '../charts/DoughnutChart';

const Campaign = ({ value, total, name }: Props) => {
  const mainColor = '#0000FF';
  const restColor = '#DDEAFF';
  const percentage = value !== 0 && total !== 0 ? Math.round((value / total) * 100) : 0;
  const rest = 100 - percentage;
  const datasets = [{ data: [ { value: percentage, label: percentage + '%' }, { value: rest, label: rest + '%' } ], backgroundColor: [ mainColor, restColor ]}];
  const labels = ['V', 'R'];
  return (
    <div className="d-flex">
      <div className="d-flex flex-column position-relative" style={{ width: 88 }}>
        <DoughnutChart datasets={datasets} labels={labels} />
        <div className="position-absolute text-center" style={{left: '50%', top: '50%', fontSize: 12.4, transform: 'translate(-50%, -50%)'}}>
          <div className="text-dark fs-5 lh-1">{value}</div>
        </div>
      </div>
      <div className="ms-3">
        {!isNaN(percentage) && <h1 className="mb-0">{percentage}%</h1>}
        <small className="text-muted">total views in<div className="text-dark text-truncate" style={{ width: 170 }}>{name}</div></small>
      </div>
    </div>
  );
}

interface Props {
  value: number,
  total: number,
  name: string
}

export { Campaign };